/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResponsiblePersonLastName/view.blocks to change it.
import Input from 'DesignSystem/Input/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function ResponsiblePersonLastName({
  children,
  viewPath = "/App/Form/Data/ProvideData/ResponsiblePersonLastName",
  onChange,
  onSubmit,
  value
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="ResponsiblePersonLastName.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z1hwwYq': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="ResponsiblePersonLastName.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginTop={4}
 marginBottom={0}
 text="What is the last name of the person responsible for the patient?"
/>
</div>
<Input
  viewPath={`${viewPath}/Input`}
 autoFocus={true}
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder="Start typing..."
 type="text"
 value={value}
/>
<Status
  viewPath={`${viewPath}/Status`}
 onSubmit={onSubmit}
/>
</div>
{children}
</React.Fragment>)
}